import React from 'react'
import { Container } from 'react-bootstrap'
import classNames from 'classnames'

import styles from './BreadcrumbContainer.module.scss'

const BreadcrumbContainer = ({ className, children }) => {
  return (
    <div className={classNames(styles.breadcrumbWrapper, className, 'd-none', 'd-lg-block')}>
      <Container className={styles.customContainer}>{children}</Container>
    </div>
  )
}

export default BreadcrumbContainer
